import React, { createContext, PropsWithChildren, useCallback, useContext, useRef, useState } from 'react';

interface BookACallFormContextData {
  isSubmitted: boolean;
  markAsSubmitted(): void;
  setPendingEmail(email: string): void;
  consumePendingEmail(): string;
}

const BookACallFormContext = createContext<BookACallFormContextData>({} as BookACallFormContextData);

const BookACallFormProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
  const pendingEmailRef = useRef<string>('');

  const markAsSubmitted = useCallback(() => {
    setIsSubmitted(true);
  }, []);

  const setPendingEmail = useCallback((email: string) => {
    pendingEmailRef.current = email;
  }, []);

  const consumePendingEmail = useCallback(() => {
    const email = pendingEmailRef.current;
    pendingEmailRef.current = '';
    return email;
  }, []);

  return (
    <BookACallFormContext.Provider
      value={{
        isSubmitted,
        markAsSubmitted,
        setPendingEmail,
        consumePendingEmail,
      }}
    >
      {children}
    </BookACallFormContext.Provider>
  );
};

const useBookACallFormContext = (): BookACallFormContextData => {
  const context = useContext(BookACallFormContext);

  if (!context) {
    throw new Error('useBookACallFormContext must be used within a BookACallFormProvider');
  }

  return context;
};

export { useBookACallFormContext, BookACallFormProvider };
